import { Layout, Menu } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { decryptData } from '../../storageHelper.ts';
const { Sider } = Layout;

const items = [
  { key: "/dashboard",icon: <img src="/sidebar/dashboard.svg" width="22" height="22"  alt="img"/>, label: <Link to="/dashboard">Dashboard</Link>,ability:"dasboard" },
  { key: "/clients",icon: <img src="/sidebar/clients.svg" width="22" height="22"  alt="img"/>, label: <Link to="/clients">Clients</Link>,ability:"clients" },
  { key: "/vendors",icon: <img src="/sidebar/vendors.svg" width="22" height="22"  alt="img"/>, label: <Link to="/vendors">Vendors</Link>,ability:"vendors" },
  { key: "/requests",icon: <img src="/sidebar/requests.svg" width="22" height="22"  alt="img"/>, label: <Link to="/requests">Requests</Link>,ability:"requests" },
  { key: "/assignments",icon: <img src="/sidebar/assignments.svg" width="22" height="22"  alt="img"/>, label: <Link to="/assignments">Assignments</Link>,ability:"assignments" },
  { key: "/master", icon: <img src="/sidebar/dashboard.svg" width="22" height="22" alt="img" />, label: "Masters",
    children: [
      { key: "/masters/service-master", label: <Link to="/masters/service-master">Service Master</Link>, ability: "master" },
      { key: "/masters/sub-service-master", label: <Link to="/masters/sub-service-master">Sub-Service Master</Link>, ability: "master" }
    ],
    ability: "master"
  }
];

const Sidebar = () => {
  const location = useLocation();


  // const [menuItems, setMenuItems] = useState<any[]>([]);

  // useEffect(() => {
  //   async function loadMenuItems() {
  //     try {
  //       // const userPermissions = localStorage.getItem('permission');
  //       const encryptedPermission = localStorage.getItem('permission');
  //       const userPermissions = decryptData(encryptedPermission);
  //       // const parsedPermissions = userPermissions ? JSON.parse(userPermissions) : [];

  //       if (userPermissions.length > 0) {
  //         const subjects = userPermissions.map((perm: any) => perm.subject);
  //         const visibleItems = items.filter(item => {
  //           const hasPermission = item.ability && subjects.includes(item.ability.toLowerCase());
  //           if (item.children && item.children.length > 0) {
  //             item.children = item.children.filter(child => child.ability && subjects.includes(child.ability.toLowerCase()));
  //           }
  //           return hasPermission || (item.children && item.children.length > 0);
  //         });
  //         const formattedItems = visibleItems.map(({ key, icon, label, children }) => ({ key, icon, label, children }));

  //         setMenuItems(formattedItems);
  //       }
  //     } catch (error) {
  //       console.error('Error loading menu items:', error);
  //       setMenuItems([]);
  //     }
  //   }

  //   loadMenuItems();
  // }, []);



  return (
    <>
      <Sider className="w-[100%] h-screen fixed" style={{ overflowY: 'auto' }}>
        <div className="mx-[12px] my-[24px]">
          <div className="w-[120px] h-[68px] mx-12">
            <img src="/sidebar/logo.svg" alt="logo" />
          </div>
          <div className="mt-[60px]">
            <Menu mode="inline"
              defaultSelectedKeys={["/dashboard"]}
              selectedKeys={[location.pathname === "/" ? "/dashboard" : location.pathname]}
              items={items} className="" />
          </div>
        </div>
      </Sider>
    </>
  )
}

export default Sidebar;